export default __webpack_public_path__ + "static/media/developzh.2e54d7a2.png";